/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Description_2Inputs */

const bn_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি নির্দিষ্ট রুটের জন্য প্রতিদিনের চ্যালেঞ্জ, এছাড়াও অঞ্চল, দ্বীপ দেশ, মাইক্রোস্টেট এবং বিস্তৃত বিশ্ব পুল জুড়ে কাস্টম রান।`)
};

const de_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tägliche Herausforderung für eine feste Route sowie individuelle Läufe durch Regionen, Inselstaaten, Mikrostaaten und größere Weltpools.`)
};

const el_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καθημερινή πρόκληση για μία σταθερή διαδρομή, καθώς και προσαρμοσμένες διαδρομές σε περιοχές, νησιωτικά έθνη, μικροπολιτεία και ευρύτερες παγκόσμιες πισίνες.`)
};

const en_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily challenge for one fixed route, plus custom runs across regions, island nations, microstates, and broader world pools.`)
};

const es_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafío diario para una ruta fija, además de recorridos personalizados por regiones, naciones insulares, microestados y grupos mundiales más amplios.`)
};

const fr_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un défi quotidien avec un parcours fixe, plus des parties personnalisées par régions, nations insulaires, micro-États et pools mondiaux plus larges.`)
};

const hi_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक निश्चित मार्ग के लिए दैनिक चुनौती, साथ ही क्षेत्रों, द्वीप राष्ट्रों, सूक्ष्म राज्यों और व्यापक विश्व पूलों में कस्टम रन।`)
};

const hu_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napi kihívás egyetlen rögzített útvonalon, valamint egyedi futások régiókon, szigetországokon, mikroállamokon és szélesebb világban.`)
};

const id_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tantangan harian untuk satu rute tetap, ditambah jalur khusus melintasi wilayah, negara kepulauan, negara mikro, dan kumpulan dunia yang lebih luas.`)
};

const it_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfida quotidiana per un percorso fisso, oltre a corse personalizzate attraverso regioni, nazioni insulari, microstati e pool mondiali più ampi.`)
};

const ja_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 つの固定ルートに対する毎日のチャレンジに加え、地域、島嶼国、小国家、およびより広い世界のプールにわたるカスタム ランにも挑戦します。`)
};

const ko_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하나의 고정 경로에 대한 일일 도전과 더불어 지역, 섬 국가, 소규모 주 및 더 넓은 세계 풀을 가로지르는 맞춤형 달리기입니다.`)
};

const nl_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijkse uitdaging voor één vaste route, plus aangepaste routes door regio's, eilandstaten, microstaten en bredere wereldpools.`)
};

const pl_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codzienne wyzwanie dla jednej ustalonej trasy oraz niestandardowe trasy przez regiony, kraje wyspiarskie, mikropaństwa i szersze pule świata.`)
};

const pt_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafio diário para uma rota fixa, além de rotas personalizadas entre regiões, nações insulares, microestados e grupos mundiais mais amplos.`)
};

const ru_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневные испытания по одному фиксированному маршруту, а также специальные заезды по регионам, островным государствам, микрогосударствам и более широким кругам мира.`)
};

const sv_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daglig utmaning för en fast rutt, plus anpassade körningar över regioner, ö-nationer, mikrostater och pooler i en bredare värld.`)
};

const tr_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabit bir rota için günlük mücadelenin yanı sıra bölgeler, ada ülkeleri, mikro eyaletler ve daha geniş dünya havuzları arasında özel koşular.`)
};

const uk_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щоденне завдання для одного фіксованого маршруту, а також користувальницькі пробіжки по регіонах, острівних державах, мікродержавах і ширших світових басейнах.`)
};

const vi_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử thách hàng ngày cho một tuyến đường cố định, cộng với các chuyến chạy tùy chỉnh giữa các khu vực, quốc đảo, tiểu bang và nhóm thế giới rộng lớn hơn.`)
};

const zh_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一条固定路线的每日挑战，以及跨地区、岛国、微型国家和更广泛的世界池的定制跑步。`)
};

const zh_hant_about_description_2 = /** @type {(inputs: About_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一條固定路線的每日挑戰，以及跨地區、島國、微型國家和更廣泛的世界池的客製化跑步。`)
};

/**
* | output |
* | --- |
* | "Daily challenge for one fixed route, plus custom runs across regions, island nations, microstates, and broader world pools." |
*
* @param {About_Description_2Inputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const about_description_2 = /** @type {((inputs?: About_Description_2Inputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Description_2Inputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_about_description_2(inputs)
	if (locale === "de") return de_about_description_2(inputs)
	if (locale === "el") return el_about_description_2(inputs)
	if (locale === "en") return en_about_description_2(inputs)
	if (locale === "es") return es_about_description_2(inputs)
	if (locale === "fr") return fr_about_description_2(inputs)
	if (locale === "hi") return hi_about_description_2(inputs)
	if (locale === "hu") return hu_about_description_2(inputs)
	if (locale === "id") return id_about_description_2(inputs)
	if (locale === "it") return it_about_description_2(inputs)
	if (locale === "ja") return ja_about_description_2(inputs)
	if (locale === "ko") return ko_about_description_2(inputs)
	if (locale === "nl") return nl_about_description_2(inputs)
	if (locale === "pl") return pl_about_description_2(inputs)
	if (locale === "pt") return pt_about_description_2(inputs)
	if (locale === "ru") return ru_about_description_2(inputs)
	if (locale === "sv") return sv_about_description_2(inputs)
	if (locale === "tr") return tr_about_description_2(inputs)
	if (locale === "uk") return uk_about_description_2(inputs)
	if (locale === "vi") return vi_about_description_2(inputs)
	if (locale === "zh") return zh_about_description_2(inputs)
	return zh_hant_about_description_2(inputs)
});